import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CollectionModel } from '../../models/collection.model';
import { OrganizationModel } from '../../models/organization.model';
import { Select } from '@ngxs/store';
import { OrganizationsState } from '../../state/organizations.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-collection-picker',
  templateUrl: './collection-picker.component.html',
  styleUrls: ['./collection-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionPickerComponent implements OnInit {

  @Select(OrganizationsState.getOrganization)
  organization$: Observable<OrganizationModel>;

  @Select(OrganizationsState.getCollections)
  collections$: Observable<CollectionModel[]>;
  
  @Input()
  selectionLabel = '';

  @Output()
  privateSelected = new EventEmitter();

  @Output()
  organizationSelected = new EventEmitter<OrganizationModel>();

  @Output()
  collectionSelected = new EventEmitter<CollectionModel>();

  constructor() { }

  ngOnInit() {
  }

  handleClickPrivate() {
    this.privateSelected.emit();
  }

  handleClickOrganization(organzation: OrganizationModel) {
    this.organizationSelected.emit(organzation);
  }

  handleClickCollection(collection: CollectionModel) {
    this.collectionSelected.emit(collection);
  }

}
